export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_02.8526524a.jpg";